import { Controller } from '@hotwired/stimulus';

const DISPLAY_NOTIFICATION_DURATION_MS = 4000;

export default class extends Controller {
  static values = { type: String };

  connect() {
    if (this.typeValue === 'pending') return;

    setTimeout(this.hide.bind(this), DISPLAY_NOTIFICATION_DURATION_MS);
  }

  hide() {
    this.element.hidden = true;
  }
}
